export const eSignChinaLegalNoticeDialog = {
  "title": "",
  "notice0": "",
  "notice1": "",
  "notice2": "",
  "notice3": "",
  "notice4": "",
  "notice5": "",
  "cancelBtn": "",
  "authorizeBtn": ""
}